
import { colors } from "constants/theme"

export default function IconPhone() {
    return (
        <svg width="15" height="22" viewBox="0 0 15 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.5 0H2.50001C1.40001 0 0.51001 0.9 0.51001 2V20C0.51001 21.1 1.40001 22 2.50001 22H12.5C13.6 22 14.5 21.1 14.5 20V2C14.5 0.9 13.6 0 12.5 0ZM12.5 18H2.50001V4H12.5V18ZM8.30001 12.22V13.97L11.11 11.35C11.32 11.15 11.32 10.82 11.11 10.62L8.30001 8V9.7C5.19001 10.13 3.95001 12.26 3.50001 14.4C4.61001 12.9 6.08001 12.22 8.30001 12.22Z" fill={colors.themeSecondColor} />
        </svg>
    )
}
